import { useLocation, useNavigate } from 'react-router-dom';
import { 
  Table, 
  TableHead, 
  TableHeaderRow, 
  TableHeaderCell, 
  TableBody, 
  TableRow, 
  TableDataCell, 
  Button, 
  ListItem, 
  List, 
  ButtonRow
} from '@op/opds.opux';
import { IconPrint } from '@op/opds.opux-icons/action';
import { IconPrevious } from '@op/opds.opux-icons/navigation';
import { space } from '@op/opds.tokens';
import message from '../messages/Message';
import { CurrentPricesRoute } from '../utils/routes';
import { useEffect } from 'react';


const SubCategoryCurrentPrices = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { productGroupContent, data } = location.state; // get the productGroupContent and response data from the location state.

useEffect(() => {
    const headerElement = document.querySelector('h2.header');
    if (headerElement) {
      headerElement.scrollIntoView({ behavior: 'smooth' });
    }
  }, []);

  const handlePrint = () => {
    window.print();
  };

 const handleBackClick = () => {
         navigate(CurrentPricesRoute, { state: { scrollToElement: true } });

      };

      useEffect(() => {
          if (location.state?.scrollToElement) {
            const element = document.querySelector('h2.header');
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' });
            }
          }
        }, [location]);

  const groupNames = productGroupContent.reduce((acc, product) => {
    if (product.productGroupName && !acc.includes(product.productGroupName)) {
      acc.push(product.productGroupName);
    }
    return acc;
  }, []);

  return (
    <div>
      <h3 className='subCategoryHeading'>{data.pricelistName}</h3>
       {groupNames.length > 0 && (
        <>
          <List size="tiny" border="none" style={{ margin: 0 }}>
            {groupNames.map((groupName, groupNameIndex) => (
              <ListItem
                key={groupNameIndex}
                onClick={() => {
                  const table = document.getElementById(groupName);
                  if (table) {
                    table.scrollIntoView({ behavior: 'smooth' });
                  }
                }}
                onKeyDown={(event) => {
                  if (event.key === 'Enter') {
                    const table = document.getElementById(groupName);
                    if (table) {
                      table.scrollIntoView({ behavior: 'smooth' });
                    }
                  }
                }}
                tabIndex={0} // Make the ListItem focusable
              >
                {groupName}
              </ListItem>
            ))}
          </List>
        </>
      )}
        <ButtonRow className='buttonHolder'>
          <Button compact onClick={handleBackClick} icon={IconPrevious} iconPos="left">
            {message('productList_backToCatalog')}
          </Button>
          <Button icon={IconPrint} compact style={{ marginRight: space.small}} onClick={handlePrint}>
            {message('print_Button')}
          </Button>
        </ButtonRow>
      {productGroupContent && productGroupContent.length > 0 ? (
        <>
          {productGroupContent.reduce((acc, product) => {
            const index = acc.findIndex((group) => group.name === product.productGroupName);
            if (index === -1) {
              acc.push({ name: product.productGroupName, products: [product] });
            } else {
              acc[index].products.push(product);
            }
            return acc;
          }, []).map((group, groupIndex) => (
            <Table key={groupIndex} spacing="small" zebra={true} id={group.name}>
              <TableHead>
                <TableHeaderRow>
                  <TableHeaderCell scope="col" tabindex="0">{group.name}</TableHeaderCell>
                  <TableHeaderCell align="right" scope="col" tabindex="0">{message('productList_price')}</TableHeaderCell>
                </TableHeaderRow>
              </TableHead>
              <TableBody>
                {group.products.map((product, productIndex) => (
                  <TableRow key={productIndex}>
                    <TableDataCell align="left" tabindex="0">{product.product}</TableDataCell>
                    <TableDataCell align="right" tabindex="0">
                      {product.price !== 0 ? (
                        <span className='priceBox'>
                          {product.price.toLocaleString('fi-FI', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}{' '}
                          €
                        </span>
                      ) : (
                        product.priceText
                      )}
                    </TableDataCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ))}
        </>
      ) : (
        <p>No products to display.</p>
      )}
      <ButtonRow className='buttonHolder'>
        <Button compact onClick={handleBackClick} icon={IconPrevious} iconPos="left">
          {message('productList_backToCatalog')}
        </Button>
        <Button icon={IconPrint} compact style={{ marginRight: space.small}} onClick={handlePrint}>
          {message('print_Button')}
        </Button>
      </ButtonRow>
    </div>
  );
};

export default SubCategoryCurrentPrices;